import { makeStyles } from '@material-ui/core';
import { Spinner } from 'react-bootstrap';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import _isEmpty from 'lodash/isEmpty';
import _valuesIn from 'lodash/valuesIn';
import _isEqual from 'lodash/isEqual';
import _get from 'lodash/get';
import { PATH } from 'routes/constant';
import themes from 'styles/themes';
import { useEffect, useRef, useCallback, useMemo } from 'react';
import warningIcon from '../../../assets/svg/warning.svg';
import addPhotoIcon from '../../../assets/svg/add_photo.svg';
import EditIcon from '../../../assets/svg/edit_dark.svg';
import ModalFull, { ETitleModal } from 'component/modal_full_screen';
import { useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
import { UPLOAD_BASE_64 } from 'graph_ql/createStyle/mutation';
import { GET_QUIZ_RESPONSE } from 'graph_ql/getQuiz/queries';
import { CREATE_ANSWERS, DELETE_ANSWER } from 'graph_ql/getQuiz/mutation';
import StandardPopup from 'component/StandardPopup';
import { ToastType } from 'constants/index';
import { useSpinnerLoading } from 'hooks/useSpinnerLoading';
import { GET_USER_BY_USERNAME } from 'graph_ql/users/queries';
import ZoomImage from 'component/zoom_image';
import { EQuizId, ESubjectQuestion, quizContextType } from 'types/quiz';
import { trackEvent, TRACK_EVENT } from 'utils/analytics';
import { PrivateImage } from 'features/authorize/private_img';
import { v4 as uuidv4 } from 'uuid';
import CustomizeLayoutQuiz from 'component/layout_quiz/layout_quiz';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { getDynamicHeight, getDynamicWidth } from 'utils/utils';

export const useStyles = makeStyles(() => ({
    container: {
        height: '100%',
        padding: '16px 16px 0px 16px',
        display: 'flex',
        flexDirection: 'column',
    },
    scrollableContainer: {
        display: 'flex',
        flex: 1,
        overflowY: 'scroll',
        flexDirection: 'column',
    },
    description: {
        fontFamily: 'Fraunces',
        fontSize: '18px',
        fontWeight: 400,
        textAlign: 'center',
        padding: '0% 5%',
    },
    photoCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        marginTop: '20px',
        flexWrap: 'wrap',
    },
    photoCard: {
        height: '217px',
        width: '165px',
        borderRadius: '16px',
        marginTop: '12px',
        backgroundPosition: 'top',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        display: 'flex',
    },
    photoCardInnerContainer: {
        display: 'flex',
        flex: 1,
        borderRadius: '16px',
        position: 'relative',
    },
    editIconContainer: {
        backgroundColor: '#F2D4BD',
        borderRadius: '50px',
        position: 'absolute',
        top: 10,
        right: 10,
        display: 'flex',
        padding: '5px',
        justifyContent: 'center',
        alignItems: 'center',
    },
    captionChip: {
        position: 'absolute',
        left: 10,
        bottom: 10,
        backgroundColor: '#F2F2F2',
        borderRadius: '50px',
        fontSize: '10px',
        fontFamily: 'Poppins',
        padding: '4px 12px',
        width: 'fit-content',
        border: '1px solid #D1D1D1',
    },
    blurBg: {
        position: 'absolute',
        height: '100%',
        width: '100%',
        backdropFilter: 'blur(5px)',
        borderRadius: '16px',
    },
    cardUploading: {
        display: 'flex',
        borderRadius: '16px',
        flexDirection: 'column',
        flex: 1,
        backgroundColor: 'rgba(26, 26, 26, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '14px',
        fontFamily: 'Poppins',
        color: '#ffffff',
    },
    cardError: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        backgroundColor: '#ffffff',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '16px',
        fontFamily: 'Poppins',
        color: '#EA4A5A',
        borderRadius: '16px',
        border: '1px dashed #767676',
    },
    addPhotoCard: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '16px',
        fontFamily: 'Poppins',
        color: '#EA4A5A',
        borderRadius: '16px',
        border: '1px dashed #767676',
    },
    addText: {
        fontSize: '14px',
        fontFamily: 'Poppins',
        color: '#000000',
    },
    NoPhotoText: {
        fontSize: '14px',
        fontFamily: 'Poppins',
        color: '#000000',
        padding: '0px 10px',
        textAlign: 'center',
    },
    warningIcon: {
        height: '20px',
        marginBottom: '10px',
    },
    addPhotoIcon: {
        height: '30px',
        marginBottom: '10px',
    },
    editIcon: {
        height: '12px',
    },
    retryButton: {
        padding: '4px 12px',
        fontSize: '12px',
        fontWeight: 600,
        fontFamily: 'Poppins',
        border: '2px solid #000000',
        color: '#000000',
        borderRadius: '50px',
        marginTop: '10px',
    },
    continueButton: {
        padding: '12px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#1A1A1A',
        color: '#ffffff',
        borderRadius: '50px',
        margin: '20px 0px',
        fontFamily: 'Poppins',
        fontSize: '14px',
    },
    skipButton: {
        padding: '12px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#000000',
        borderRadius: '50px',
        margin: '10px 0px',
        fontFamily: 'Poppins',
        fontSize: '14px',
    },
    continueContainer: {
        width: '100%',
        left: 0,
        maxWidth: 500,
        margin: 'auto',
        right: 0,
        padding: '0 24px',
        background: themes.palette.primary.light,
        bottom: 0,
    },
    continue: {
        color: themes.palette.primary.main,
        fontSize: 14,
        width: '100%',
        height: 56,
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        fontWeight: 600,
        fontFamily: 'PoppinsRegular',
        background: themes.palette.primary.light,
        textTransform: 'uppercase',
    },
}));

interface Ianswer {
    title?: string;
    value?: string;
    isUploading?: boolean;
    isError?: boolean;
    id?: String;
    answerId?: string;
    userProperty?: string;
    answerUpdated?: string;
    action?: string;
    isSkipped?: string;
    required?: boolean;
}

interface Imutation {
    questionId?: String;
    questionSubject?: String;
    contextType?: String;
    contextId?: String;
    value?: String;
    valueType?: String;
    id?: String;
    action?: String;
    isSkipped?: boolean;
}

enum EMutations {
    CREATE_ANSWER = 'CREATE_ANSWER',
    DELETE_ANSWER = 'DELETE_ANSWER',
}

export enum EValueAnswers {
    LIKE = 'LIKE',
    DISLIKE = 'DISLIKE',
}

const MAX_IMAGE_SIZE = 7000000; //7mb in bytes

const MyPhotos = () => {
    const location = useLocation();
    const classes = useStyles();
    const history = useHistory();
    const me = useSelector((state: RootState) => state.userDetail.me);
    const bodyShapeDefault = useSelector((state: RootState) => state.userDetail.bodyShapeDefault);
    const bodyTypeDefault = useSelector((state: RootState) => state.userDetail.bodyTypeDefault);
    const personaDefault = useSelector((state: RootState) => state.userDetail.personaDefault);
    const birthdayDefault = useSelector((state: RootState) => state.userDetail.myBirthday);
    const skinToneDefault = useSelector((state: RootState) => state.userDetail.skinToneDefault);
    const skinUndertoneDefault = useSelector((state: RootState) => state.userDetail.skinUndertoneDefault);
    const hairColorDefault = useSelector((state: RootState) => state.userDetail.hairColorDefault);
    const inputFileRef = useRef<HTMLInputElement | null>(null);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [currentEditItem, setCurrentEditItem] = useState<Ianswer>({});
    const [photoList, setPhotoList] = useState<Ianswer[]>([]);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [requiredQuestion, setRequiredQuestion] = useState(true);
    const [initialPhotoList, setInitialPhotoList] = useState<Ianswer[]>([]);
    const [lastUploadedImage, setLastUploadedImage] = useState<React.ChangeEvent<HTMLInputElement>>();
    const [showImage, setShowImage] = useState(false);
    const [zoomImg, setZoomImg] = useState('');
    const [answerLoading, setAnswerLoading] = useState(false);
    const [quizData, setQuizData] = useState<any>(null);
    const [isSkipping, setSkipping] = useState<boolean>(false);
    const [modalShow, setModalShow] = useState({
        show: false,
        title: '',
        content: '',
        button1: '',
        button2: '',
        type: ToastType.Info,
        closeButton: true,
        firstButtonClick: () => {},
        secondButtonClick: () => {},
    });
    const { userName } = useParams<{ userName: string }>();

    const [updateBase64] = useMutation(UPLOAD_BASE_64);

    const [getUserByUserName, { loading: userLoading }] = useLazyQuery(GET_USER_BY_USERNAME, {
        onCompleted(data) {
            setAnswerLoading(true);
            getQuizResponse({
                variables: {
                    input: {
                        quizId: EQuizId.MY_PHOTOS_QUIZ,
                        contextType: quizContextType,
                        contextId: EQuizId.MY_PHOTOS_QUIZ,
                        userId: data.getUserByUserName?.id,
                    },
                },
            });
        },
    });

    useEffect(() => {
        if (userName) {
            getUserByUserName({
                variables: {
                    input: {
                        userName,
                    },
                },
            });
        }
    }, [userName, getUserByUserName]);

    const [getQuizResponse] = useLazyQuery(GET_QUIZ_RESPONSE, {
        onCompleted: (data) => {
            const listAnswers = _valuesIn(data.getQuizResponse?.answers);
            const listQuestions = _valuesIn(data.getQuizResponse?.questions);
            setQuizData(data.getQuizResponse);
            const requiredQuestions = _valuesIn(data.getQuizResponse?.questionsInfo)?.filter((item) => item.required);
            const list = listQuestions.map((item) => {
                const itemAnswered = listAnswers.find((i) => i.questionId === item.id);
                const requiredQuestion = requiredQuestions.find((i) => i.id === item.id);
                let updatedItem = {
                    ...item,
                    isUploading: false,
                    isError: false,
                    action: EMutations.CREATE_ANSWER,
                };
                if (itemAnswered) {
                    updatedItem = {
                        ...updatedItem,
                        value: itemAnswered.value,
                        answerId: itemAnswered.id,
                        answerUpdated: itemAnswered.updated,
                        isSkipped: itemAnswered.isSkipped,
                    };
                }
                if (requiredQuestion) {
                    updatedItem = {
                        ...updatedItem,
                        required: requiredQuestion.required,
                    };
                }
                return updatedItem;
            });
            setRequiredQuestion(Boolean(requiredQuestions.length));
            setInitialPhotoList(list);
            setPhotoList(list);
            setAnswerLoading(false);
        },
        onError: (err) => {
            setAnswerLoading(false);
        },
    });

    useEffect(() => {
        if (me?.id && Boolean(!userName)) {
            setAnswerLoading(true);
            getQuizResponse({
                variables: {
                    input: {
                        quizId: EQuizId.MY_PHOTOS_QUIZ,
                        contextType: quizContextType,
                        contextId: EQuizId.MY_PHOTOS_QUIZ,
                        userId: me?.id,
                    },
                },
            });
        }
    }, [me, getQuizResponse, userName]);

    const [deleteAnswerMutation, { loading: deleteAnswerLoading }] = useMutation(DELETE_ANSWER, {
        onError(error) {
            console.log('delete error', error);
        },
    });

    const handleRedirection = useCallback(() => {
        if (location.pathname.includes(PATH.QUIZ_MANAGER)) {
            getQuizResponse({
                variables: {
                    input: {
                        quizId: EQuizId.MY_PHOTOS_QUIZ,
                        contextType: quizContextType,
                        contextId: EQuizId.MY_PHOTOS_QUIZ,
                        userId: me?.id,
                    },
                },
            });
            history.push(`${PATH.QUIZ_MANAGER}/?signup=${Date.now()}`);
        } else {
            history.push(PATH.PROFILE);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history, location.pathname]);

    const handleSkipEvent = useCallback(() => {
        trackEvent(TRACK_EVENT.USER_PHOTO_SKIP, {
            userId: me?.id,
            userType: me?.userType,
            email: me?.email,
            gender: me?.gender,
            bodyType: _get(bodyTypeDefault, '[0].value', ''),
            bodyShape: _get(bodyShapeDefault, '[0].value', ''),
            personas: personaDefault?.map((item) => item?.value) || '',
            birthday: birthdayDefault,
            skinTone: skinToneDefault?.value || '',
            skinUndertone: skinUndertoneDefault?.value || '',
            hairColor: hairColorDefault?.value || '',
            myPhoto: {},
            userProperty: '',
            isSkipped: true,
        });
    }, [
        me,
        birthdayDefault,
        bodyTypeDefault,
        bodyShapeDefault,
        personaDefault,
        skinToneDefault,
        skinUndertoneDefault,
        hairColorDefault,
    ]);

    const [answersMutation, { loading: loadingAnswer }] = useMutation(CREATE_ANSWERS, {
        onCompleted(response) {
            handleRedirection();
        },
        onError(error) {
            console.log('my photos create answer error', error);
        },
    });

    const createAnswers = useCallback(
        async ({ skip = false }) => {
            let modifiedPhotoList: Ianswer[] = [];
            photoList.forEach((item) => {
                if (!item.value && !item.isSkipped) {
                    modifiedPhotoList = [...modifiedPhotoList, item];
                } else {
                    const initialPhotoObj = initialPhotoList.find((i) => i.id === item.id);
                    if (!_isEqual(initialPhotoObj, item)) {
                        modifiedPhotoList = [...modifiedPhotoList, item];
                    }
                }
            });
            let answerList = skip ? initialPhotoList : modifiedPhotoList;
            if (answerList.length) {
                let answers: Imutation[] = [];
                let deleteAnswers: Imutation[] = [];
                answerList.forEach((item) => {
                    if (item.id && item.action === EMutations.CREATE_ANSWER) {
                        let input: Imutation = {
                            contextId: EQuizId.MY_PHOTOS_QUIZ,
                            contextType: quizContextType,
                            questionId: item.id,
                            questionSubject: ESubjectQuestion.MY_PHOTOS_SUBJECT_QUESTION,
                            value: item.value || '',
                            valueType: 'UPLOAD_FILE',
                            id: item?.answerId,
                            isSkipped: !item.value ? true : undefined,
                        };
                        answers = [...answers, input];
                    } else if (item.answerId && item.action === EMutations.DELETE_ANSWER) {
                        let input = {
                            id: item?.answerId,
                        };
                        deleteAnswers = [...deleteAnswers, input];
                    }
                });

                const SaveMultipleAnswers = () => {
                    const variables = {
                        input: {
                            answers,
                        },
                    };
                    answersMutation({ variables });
                };

                setSkipping(skip);
                if (deleteAnswers.length) {
                    await Promise.all(
                        deleteAnswers.map((input) => {
                            const variables = {
                                input,
                            };
                            return deleteAnswerMutation({ variables });
                        }),
                    )
                        .then(() => {
                            if (answers.length) {
                                SaveMultipleAnswers();
                            } else {
                                handleRedirection();
                            }
                        })
                        .catch((e) => {
                            console.log('my photos create answer error', e);
                        });
                } else if (answers.length) {
                    SaveMultipleAnswers();
                }
                if (skip) {
                    handleSkipEvent();
                }
            } else {
                handleRedirection();
            }
        },
        [answersMutation, photoList, handleRedirection, deleteAnswerMutation, initialPhotoList, handleSkipEvent],
    );

    const handleDeleteAnswer = useCallback(() => {
        let updatedPhotoList = photoList.map((item) => {
            if (currentEditItem.id === item.id) {
                return {
                    ...item,
                    value: '',
                    answerUpdated: new Date().toISOString(),
                    action: EMutations.DELETE_ANSWER,
                };
            }
            return item;
        });
        setPhotoList(updatedPhotoList);
    }, [currentEditItem, photoList]);

    const uploadImage = useCallback(
        async (selectedFile: File, base64Image: string | ArrayBuffer) => {
            if (!me?.id) return;
            const signedUrl = await updateBase64({
                variables: {
                    input: {
                        filename: uuidv4(),
                        mimetype: selectedFile.type,
                        folder: `private/user-photos/${me ? me.id : ''}`,
                        data: base64Image,
                    },
                },
            });
            return signedUrl?.data?.uploadFileBase64?.url || '';
        },
        [updateBase64, me],
    );

    const getBase64 = (file) => {
        return new Promise((resolve: (res: string | ArrayBuffer) => void, reject) => {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                resolve(reader.result || '');
            };
            reader.onerror = function (error) {
                reject(error);
            };
        });
    };

    const handleEditModalClose = () => {
        setOpenEditModal(false);
    };

    const handleEditModalOpen = (item) => {
        setOpenEditModal(true);
        setCurrentEditItem(item);
    };

    const openImgModal = (item) => {
        setCurrentEditItem(item);
        inputFileRef?.current?.click();
    };

    const handleListLoading = useCallback(
        (value: boolean) => {
            let updatedPhotoList = photoList.map((item) => {
                if (currentEditItem.id === item.id) {
                    return { ...item, isUploading: value };
                }
                return item;
            });
            setPhotoList(updatedPhotoList);
        },
        [currentEditItem, photoList],
    );

    const handleListError = useCallback(
        (value: boolean) => {
            let updatedPhotoList = photoList.map((item) => {
                if (currentEditItem.id === item.id) {
                    return { ...item, isError: value };
                }
                return item;
            });
            setPhotoList(updatedPhotoList);
        },
        [currentEditItem, photoList],
    );

    const handlePhotoDelete = () => {
        handleEditModalClose();
        handleDeleteAnswer();
    };

    const displayMaxSizeError = useCallback(() => {
        setModalShow({
            show: true,
            title: 'Photo size exceeded limit',
            content: 'Maximum photo size supported is 7MB. Please upload a smaller size photo.',
            button1: 'Okay',
            button2: '',
            type: ToastType.Error,
            closeButton: false,
            secondButtonClick: async () => {},
            firstButtonClick: () => {
                setModalShow({ ...modalShow, show: false });
            },
        });
    }, [modalShow]);

    const handleChangeListImage = useCallback(
        async (e: React.ChangeEvent<HTMLInputElement>) => {
            if (openEditModal) {
                setOpenEditModal(false);
            }
            if (e.target.files) {
                setLastUploadedImage(e);
                const files: FileList = e.target.files;
                const files_array: File[] = Object.values(files);
                let base64Image: string | ArrayBuffer = '';
                if (files_array[0]?.size > MAX_IMAGE_SIZE) {
                    displayMaxSizeError();
                } else {
                    handleListLoading(true);
                    getBase64(files_array[0])
                        .then(async (res: string | ArrayBuffer) => {
                            try {
                                base64Image = res;
                                let imageURL = await uploadImage(files_array[0], base64Image);
                                if (imageURL) {
                                    let updatedPhotoList = photoList.map((item) => {
                                        if (currentEditItem.id === item.id) {
                                            return {
                                                ...item,
                                                value: imageURL,
                                                answerUpdated: new Date().toISOString(),
                                                action: EMutations.CREATE_ANSWER,
                                            };
                                        }
                                        return item;
                                    });
                                    setPhotoList(updatedPhotoList);
                                }
                            } catch (error) {
                                //upload image error
                                handleListError(true);
                            }
                        })
                        .catch((err) => {
                            //base64 error
                            handleListError(true);
                        });
                }
            } else {
                //file explorer error
                handleListError(true);
            }
        },
        [
            uploadImage,
            currentEditItem,
            photoList,
            openEditModal,
            displayMaxSizeError,
            handleListLoading,
            handleListError,
        ],
    );

    const handlePhotoDeleteAlert = () => {
        setModalShow({
            show: true,
            title: 'Delete Photo',
            content: 'Are you sure you want to delete the photo?',
            button1: 'Yes',
            button2: 'No',
            type: ToastType.Warning,
            closeButton: true,
            firstButtonClick: async () => {
                handlePhotoDelete();
            },
            secondButtonClick: () => setModalShow({ ...modalShow, show: false }),
        });
    };

    const handleViewImage = (url) => {
        setZoomImg(url);
        setShowImage(true);
    };

    const validateRequiredQuestions = () => {
        let unAnsweredRequiredQuestion = photoList.filter((item) => item.required && !item.value);
        if (unAnsweredRequiredQuestion.length) {
            return true;
        }
        return false;
    };

    // useSpinnerLoading('my_photos_user', loadingMe);
    useSpinnerLoading('my_photos_quiz', answerLoading);
    useSpinnerLoading('my_photos_consumer', userLoading);
    // useSpinnerLoading('my_photos_answer', loading?.loading);

    const validAnswer = useMemo(() => {
        return photoList.filter((item) => item.value || item.action === EMutations.DELETE_ANSWER).length > 0;
    }, [photoList]);

    return (
        <>
            <CustomizeLayoutQuiz
                quizId={EQuizId.MY_PHOTOS_QUIZ}
                title={Boolean(!userName) ? quizData?.subTitle : ''}
                titlePage={userName ? 'Photos' : quizData?.title}
                handleAnswer={() => createAnswers({ skip: false })}
                isUpdate={location.pathname !== PATH.QUIZ_MANAGER}
                isDisplayContent={Boolean(!userName)}
                isHiddenAction={validateRequiredQuestions()}
                hideBottomNav={location.pathname === PATH.QUIZ_MANAGER}
                requiredQuestion={false}
                handleSkipQuestion={async () => {
                    await createAnswers({ skip: true });
                }}
                nextBtnDisabled={!validAnswer}
                loading={(loadingAnswer || deleteAnswerLoading) && !isSkipping}
                loadingSkip={(loadingAnswer || deleteAnswerLoading) && isSkipping}
            >
                <div className={classes.container}>
                    <div className={classes.scrollableContainer}>
                        <div className={classes.photoCardContainer}>
                            {photoList.map((item, index) => {
                                return (
                                    <PrivateImage
                                        url={item.value}
                                        className={classes.photoCard}
                                        key={`${index}_${item.answerUpdated}`}
                                        style={{
                                            width: `${getDynamicWidth(165)}px`,
                                            height: `${getDynamicHeight(220, 165)}px`,
                                        }}
                                        onClick={() => {
                                            if (item.value && Boolean(userName)) {
                                                handleViewImage(item.value);
                                            }
                                        }}
                                    >
                                        <div className={classes.photoCardInnerContainer}>
                                            {item.value && !item.isUploading && Boolean(!userName) && (
                                                <div
                                                    className={classes.editIconContainer}
                                                    onClick={() => handleEditModalOpen(item)}
                                                >
                                                    <img src={EditIcon} alt="" className={classes.editIcon} />
                                                </div>
                                            )}
                                            {!item.value && !item.isUploading && (
                                                <div
                                                    className={classes.addPhotoCard}
                                                    onClick={() => {
                                                        if (Boolean(!userName)) {
                                                            openImgModal(item);
                                                        }
                                                    }}
                                                >
                                                    {Boolean(!userName) ? (
                                                        <>
                                                            <img
                                                                src={addPhotoIcon}
                                                                alt=""
                                                                className={classes.addPhotoIcon}
                                                            />
                                                            <span className={classes.addText}>Add {item.title}</span>
                                                        </>
                                                    ) : (
                                                        <span className={classes.NoPhotoText}>Not Provided</span>
                                                    )}
                                                </div>
                                            )}
                                            {item.isUploading ? (
                                                <div className={classes.cardUploading}>
                                                    <div className={classes.blurBg} />
                                                    <Spinner
                                                        animation="border"
                                                        style={{ width: 18, height: 18, marginBottom: '5px' }}
                                                    />
                                                    <span style={{ zIndex: 1 }}>UPLOADING...</span>
                                                </div>
                                            ) : null}
                                            {item.isError ? (
                                                <div className={classes.cardError}>
                                                    <img src={warningIcon} alt="" className={classes.warningIcon} />
                                                    <span>Upload Error!</span>
                                                    <div
                                                        className={classes.retryButton}
                                                        onClick={() => {
                                                            if (lastUploadedImage) {
                                                                handleChangeListImage(lastUploadedImage);
                                                            }
                                                        }}
                                                    >
                                                        RETRY
                                                    </div>
                                                </div>
                                            ) : null}
                                            {item.value || item.isError || userName ? (
                                                <div className={classes.captionChip}>{item.title}</div>
                                            ) : null}
                                        </div>
                                    </PrivateImage>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <ModalFull
                    open={openEditModal}
                    handleClose={handleEditModalClose}
                    title={!_isEmpty(currentEditItem) && currentEditItem.title ? currentEditItem.title : ''}
                    modal_code={ETitleModal.EDIT_MY_PHOTO}
                    item={currentEditItem}
                    componentProps={{
                        openImgModal,
                        handlePhotoDeleteAlert,
                    }}
                />
                <input type="file" hidden accept="image/*" ref={inputFileRef} onChange={handleChangeListImage} />
            </CustomizeLayoutQuiz>
            <StandardPopup
                show={modalShow.show}
                onHide={() => setModalShow({ ...modalShow, show: false })}
                title={modalShow.title}
                content={modalShow.content}
                button1={modalShow.button1}
                button2={modalShow.button2}
                onFirstButtonClick={modalShow.firstButtonClick!}
                onSecondButtonClick={modalShow.secondButtonClick!}
                type={modalShow.type}
                closeButton={modalShow.closeButton}
            />
            {showImage && <ZoomImage img={zoomImg} setShowImage={setShowImage} isPrivateImage />}
        </>
    );
};
export default MyPhotos;
